import { GET_REFERRALS } from './action.types';

const saveReferrals = (referrals) => (dispatch) => {
  dispatch({
    type: GET_REFERRALS,
    payload: referrals,
  });
}

export default saveReferrals